// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__28qIp","validationTips":"StatementDescriptor_validationTips__1OKJy"};